// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "platform" + "." + "f363685c5a44c79c5cb6" + ".css";
};